import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LS } from "./data/localStoreKeys";
import en from "./translations/en.json";
import nb from "./translations/nb.json";
import fi from "./translations/fi.json";
import en_us from "./translations/en_us.json";
import { COUNTRY_CODES } from "./data/data";

export enum Languages {
  EN = "en",
  NB = "nb",
  FI = "fi",
  
}

const getEnglishTranslation = () => {
  const activeCountry = import.meta.env.VITE_COUNTRY;
  return activeCountry === COUNTRY_CODES.US.toString() ? en_us : en;
};

const resources = {
  en: { translation: getEnglishTranslation() },
  nb: { translation: nb },
  fi: { translation: fi },
};

const getDefaultLanguageByCountry = () => {
  const activeCountry = import.meta.env.VITE_COUNTRY;
  
  if (activeCountry === COUNTRY_CODES.ZA.toString()) return Languages.EN;
  if (activeCountry === COUNTRY_CODES.FI.toString()) return Languages.FI;
  if (activeCountry === COUNTRY_CODES.NO.toString()) return Languages.NB;
  
  return Languages.EN;
};

export const getDefaultLanguage = () => {
  return sessionStorage.getItem(LS.CHOSEN_LANG) || getDefaultLanguageByCountry();
};

const initialLanguage = getDefaultLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage || Languages.EN,
  debug: false,
  keySeparator: false,

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;

export const changeLang = (language: string | Languages.EN) => {
  const validLanguages = [Languages.EN, Languages.NB, Languages.FI];
  if (validLanguages.includes(language as Languages)) {
    // Update session storage and i18n language
    sessionStorage.setItem(LS.CHOSEN_LANG, language);
    i18n.changeLanguage(language).catch(console.error);
  }
}